import React from 'react';
import { getLatestUserCookie } from "../Login/user_session";
import { get } from "../../utils";
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
const RedirectToReturnUrl = () => {
  const sitecoreContext = useSitecoreContext();
  const identityGlobal = get(sitecoreContext, 'configuration.globalApi.identityGlobal') || 'https://replaceidentityGlobal';
  const clientId = get(sitecoreContext, 'configuration.globalApi.clientId') || 'replaceint2';
  const clientSecret = get(sitecoreContext, 'configuration.globalApi.clientSecret') || 'replacesecret';
  React.useEffect(() => {
    getLatestUserCookie(identityGlobal, clientId, clientSecret).then(value => {
      let userCookie = value;
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');
        const redirect_url = urlParams.get('redirect_url');
        if (redirect_url) {
          if (userCookie && userCookie.access_token) {
            window.location = redirect_url;
          } else {
            window.location.pathname = `/login`;
          }
        }
      }
    });
  }, []);
  return null;
};
export default RedirectToReturnUrl;